namespace RioERP.Masters {
    export interface Rioplay8AllowedDevicesForm {
        Id: Serenity.StringEditor;
        Device: Serenity.StringEditor;
    }

    export class Rioplay8AllowedDevicesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.Rioplay8AllowedDevices';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Rioplay8AllowedDevicesForm.init)  {
                Rioplay8AllowedDevicesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(Rioplay8AllowedDevicesForm, [
                    'Id', w0,
                    'Device', w0
                ]);
            }
        }
    }
}
